import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";

// Partners are grouped into categories for display. `match` is a lowercase
// keyword used to pair each entry with the logo coming back from the API
// (matched against the logo's alt text / image filename).
const PARTNER_CATEGORIES = [
  {
    items: [
      { name: "Cisco", match: "cisco" },
      { name: "Versa Networks", match: "versa" },
      { name: "Aruba", match: "aruba" },
      { name: "Dell", match: "dell" },
      { name: "Hitachi Vantara", match: "hitachi" },
    ],
  },
  {
    items: [
      { name: "Microsoft", match: "microsoft" },
      { name: "AWS", match: "aws" },
      { name: "Oracle", match: "oracle" },
      { name: "VMware", match: "vmware" },
      { name: "Google", match: "google" },
    ],
  },
  {
    items: [
      { name: "Fortinet", match: "fortinet" },
      { name: "Honeywell", match: "honeywell" },
      { name: "Apple", match: "apple" },
    ],
  },
];

export default function Partners() {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    axios
      .post(`${API_BASE_URL}/api/ourPartners/getAllourPartners`)
      .then((response) => {
        if (response?.data?.error === false) {
          const data = response.data.data?.our_partners?.our_partners_data || [];
          setLogos(data);
        }
      })
      .catch(() => {
        setLogos([]);
      });
  }, []);

  // Find the API logo for a given partner using its match keyword.
  const findLogo = (keyword) =>
    logos.find((logo) => {
      const haystack = `${logo?.altText || ""} ${logo?.image || ""}`.toLowerCase();
      return haystack.includes(keyword);
    });

  if (logos.length === 0) {
    return null;
  }

  return (
    <div className="home-partners section-space">
      <div className="container">
        <h2 className="home-partners__heading">Our Partners</h2>
        <p className="home-partners__subtitle">
          We collaborate with the world&rsquo;s leading technology brands to deliver best-in-class solutions.
        </p>

        {PARTNER_CATEGORIES.map((category) => {
          const cards = category.items
            .map((partner) => ({ partner, logo: findLogo(partner.match) }))
            .filter((entry) => entry.logo);

          if (cards.length === 0) {
            return null;
          }

          return (
            <div className="home-partners__group" key={category.title}>
              <h3 className="home-partners__group-title">{category.title}</h3>
              <div className="home-partners__grid">
                {cards.map(({ partner, logo }) => (
                  <div className="partner-card" key={partner.name}>
                    <img
                      className="partner-card__logo"
                      src={logo.image}
                      alt={logo.altText || partner.name}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
